import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface IconBackdropProps {
  $tone?: 'accent' | 'success' | 'warning' | 'error';
  $size?: 'small';
}

export const IconBackdrop = styled.div.withConfig({ componentId: 'sc-h5fztp-0' })<IconBackdropProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--icon-backdrop-size, ${size(5)});
    height: var(--icon-backdrop-size, ${size(5)});
    border-radius: 50%;
    background-color: var(--icon-backdrop-bg, var(--c-bg-alt));
    color: var(--icon-backdrop-fg, var(--c-text-main));
    font-size: var(--icon-backdrop-font-size, ${(props) => props.theme.font.size.regular});

    ${({ $tone }) =>
      $tone === 'accent'
        ? css`
                  --icon-backdrop-bg: var(--c-accent-alt-bg);
                  --icon-backdrop-fg: var(--c-accent-alt-fg);
              `
        : $tone === 'success'
          ? css`
                  --icon-backdrop-bg: var(--c-semantic-success-300);
                  --icon-backdrop-fg: var(--c-semantic-success-700);
              `
          : $tone === 'warning'
            ? css`
                  --icon-backdrop-bg: var(--c-semantic-warning-300);
                  --icon-backdrop-fg: var(--c-semantic-warning-700);
              `
            : $tone === 'error'
              ? css`
                  --icon-backdrop-bg: var(--c-semantic-error-300);
                  --icon-backdrop-fg: var(--c-semantic-error-700);
              `
              : undefined}

    ${({ $size }) =>
      $size === 'small'
        ? css`
                  --icon-backdrop-size: ${size(3)};
                  --icon-backdrop-font-size: var(--font-size-xsmall-static);
              `
        : undefined}
`;
